var Kowloon = "Коулун";
var HKStates = {
	"Hong Kong Island": "Остров Гонконг",
	Kowloon: Kowloon,
	"Lantau Island": "Остров Лантау",
	"New Territories": "Новые территории"
};

export { Kowloon, HKStates as default };
